export const MENU_CHANGE_FORM_MANAGEMENT = 'Agent Profile - Agent Profile Update Form';
